import { StoreListComponent } from './store-list.component';

export default StoreListComponent;
